const ko = {
  // Navbar
  nav_contact: '문의하기',
  nav_cta: '리스쿱 시작',

  // Footer
  footer_tagline: 're.scoop은 크리에이터를 위한 AI 인박스입니다.\n팬·브랜드 메시지를 놓치지 않도록 도와요.',
  footer_product: '제품',
  footer_company: '회사',
  footer_how_it_works: '사용 방법',
  footer_use_cases: '활용 사례',
  footer_trust: '신뢰 & 제어',
  footer_privacy: '개인정보처리방침',
  footer_terms: '서비스 약관',
  footer_copyright: '© 2026 iconX Inc. All rights reserved.',

  // Problem Section
  problem_card_brand: '브랜드 제안이 DM 속에 묻혀버려요',
  problem_card_fan: '찐팬 메시지가 댓글 아래로 자꾸 밀려요',
  problem_card_link: '공구 링크 요청이 여러 채널에 흩어져 있어요',
  problem_card_spam: '스팸과 악성 메시지는 보기 싫어요',
  problem_headline_1: '중요한 것들이 자꾸',
  problem_headline_2: '아래로 숨어버리나요?',
  problem_sub: '매일 쏟아지는 알림 속에서, 정작 지금 봐야 할 메시지는 가장 깊은 곳으로 가라앉습니다.',
  problem_notif_unread: '읽지 않은 알림',

  // Trust
  trust_headline_1: 'AI는 거들 뿐,',
  trust_headline_2: '결정도, 메시지도',
  trust_headline_3: '크리에이터의 것.',
  trust_c1_title: 'AI는 분류만,\n발신은 크리에이터가',
  trust_c1_desc: '리스쿱의 AI는 메시지를 자동으로 보내지 않아요. 어떤 종류의 메시지인지, 중요한지 아닌지를 판단해 분류·정리만 도와요.',
  trust_c2_title: '메시지는 온전히\n크리에이터의 것',
  trust_c2_desc: '받은 메시지는 분류 외 어떤 외부 학습·광고·제3자 공유에도 사용되지 않아요.',
  trust_c3_title: '계정정지 리스크 없는\n안전한 처리 방식',
  trust_c3_desc: '자동 메시지 생성·발송은 최소화했어요. 리스쿱은 사용자가 진정성 있는 답장을 가장 쉽게 보낼 수 있도록 만든 플랫폼이에요.',

  // Final CTA
  final_headline_1: '오늘부터,',
  final_headline_2: '중요한 소통만',
  final_headline_3: '먼저.',
  final_sub: 'YouTube 댓글과 Gmail부터 가볍게 시작하세요. 리스쿱이 팬과 브랜드의 메시지를 먼저 스쿱해 드립니다.',
  final_cta: '리스쿱 시작하기',
  final_contact: '팀에 문의하기',
  final_trust_1: '무료 플랜 제공',
  final_trust_2: '개인정보 안전 보호',
  final_trust_3: '구글계정으로 바로 연결 완료',

};

export default ko;
